function initPersonalizer() {
  const root = document.querySelector('[data-pm-root]');
  if (!root) return;
  if (root.dataset.pmInitialized === 'true') return;
  root.dataset.pmInitialized = 'true';

  const openButtons = root.querySelectorAll('[data-pm-open]');
  const modal = root.querySelector('[data-pm-modal]');
  const closeButtons = root.querySelectorAll('[data-pm-close]');

  const stepIndicators = root.querySelectorAll('[data-step-indicator]');
  const stepPanels = root.querySelectorAll('[data-step-panel]');

  const backButton = root.querySelector('[data-pm-back]');
  const nextButton = root.querySelector('[data-pm-next]');
  const applyButton = root.querySelector('[data-pm-apply]');

  const frontFileInput = root.querySelector('[data-pm-front-file]');
  const frontFileName = root.querySelector('[data-pm-front-file-name]');
  const frontError = root.querySelector('[data-pm-front-error]');

  const backTypeInputs = root.querySelectorAll('input[name="pm-back-type"]');
  const backPanels = root.querySelectorAll('[data-back-panel]');

  const backTextInput1 = root.querySelector('[data-pm-back-text-1]');
  const backTextInput2 = root.querySelector('[data-pm-back-text-2]');
  const backTextInput3 = root.querySelector('[data-pm-back-text-3]');
  const fontSelect = root.querySelector('[data-pm-font-select]');

  const handwritingInput = root.querySelector('[data-pm-handwriting-file]');
  const handwritingFileName = root.querySelector('[data-pm-handwriting-file-name]');
  const handwritingError = root.querySelector('[data-pm-handwriting-error]');

  const backPortraitInput = root.querySelector('[data-pm-back-portrait-file]');
  const backPortraitFileName = root.querySelector('[data-pm-back-portrait-file-name]');
  const backPortraitError = root.querySelector('[data-pm-back-portrait-error]');

  const giftBoxInputs = root.querySelectorAll('input[name="pm-giftbox"]');

  const reviewOutput = root.querySelector('[data-pm-review-output]');
  const summaryBox = root.querySelector('[data-pm-summary-box]');
  const summaryOutput = root.querySelector('[data-pm-summary-output]');

  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;

  const completeInput = productForm.querySelector('[data-pm-complete]');
  const addButton = productForm.querySelector('[type="submit"]');
  const mainVariantInput = productForm.querySelector('input[name="id"]');

  let currentStep = 1;
  let isSubmitting = false;

  const UPLOADCARE_PUBLIC_KEY = '6ccf1aa26fbfd6bbab8b';
  const UPLOADCARE_UPLOAD_URL = 'https://upload.uploadcare.com/base/';
  const UPLOADCARE_CDN_BASE = 'https://4b3bdujx31.ucarecd.net/';

  const ADDON_VARIANTS = {
    giftboxWhite: 53443709174106,
    giftboxBlack: 54060005917018,
    extraImage: 53443708944730
  };

  const state = {
    frontFile: null,
    frontUploadUrl: '',
    backType: 'text',
    backText1: '',
    backText2: '',
    backText3: '',
    backFont: 'instrument-sans',
    handwritingFile: null,
    handwritingUploadUrl: '',
    backPortraitFile: null,
    backPortraitUploadUrl: '',
    giftBox: 'none'
  };

  const fontMap = {
    'instrument-sans': "'Instrument Sans', sans-serif",
    'playfair': "'Playfair Display', serif",
    'cormorant': "'Cormorant Garamond', serif",
    'dancing-script': "'Dancing Script', cursive"
  };

  async function uploadToUploadcare(file) {
    const formData = new FormData();
    formData.append('UPLOADCARE_PUB_KEY', UPLOADCARE_PUBLIC_KEY);
    formData.append('UPLOADCARE_STORE', '1');
    formData.append('file', file);

    const response = await fetch(UPLOADCARE_UPLOAD_URL, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error('Uploadcare upload failed');
    }

    const data = await response.json();

    if (!data.file) {
      throw new Error('No file id returned from Uploadcare');
    }

    return {
      uuid: data.file,
      cdnUrl: `${UPLOADCARE_CDN_BASE}${data.file}/`
    };
  }

  function openModal() {
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pm-modal-open');
    goToStep(currentStep);
  }

  function closeModal() {
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pm-modal-open');
  }

  function goToStep(step) {
    currentStep = step;

    stepPanels.forEach(panel => {
      panel.classList.toggle('is-active', Number(panel.dataset.stepPanel) === step);
    });

    stepIndicators.forEach(indicator => {
      const indicatorStep = Number(indicator.dataset.stepIndicator);
      indicator.classList.toggle('is-active', indicatorStep === step);
      indicator.classList.toggle('is-complete', indicatorStep < step);
    });

    if (step === 1) {
      backButton.classList.add('hidden');
      nextButton.classList.remove('hidden');
      applyButton.classList.add('hidden');
    } else if (step === 4) {
      backButton.classList.remove('hidden');
      nextButton.classList.add('hidden');
      applyButton.classList.remove('hidden');
      renderReview();
    } else {
      backButton.classList.remove('hidden');
      nextButton.classList.remove('hidden');
      applyButton.classList.add('hidden');
    }
  }

  function updateBackContent() {
    backPanels.forEach(panel => {
      panel.classList.toggle('is-active', panel.dataset.backPanel === state.backType);
    });
  }

  function hideErrors() {
    frontError.classList.add('hidden');
    handwritingError.classList.add('hidden');
    backPortraitError.classList.add('hidden');
  }

  function hasAnyTextLine() {
    return [state.backText1, state.backText2, state.backText3].some(line => line && line.trim() !== '');
  }

  function validateStep(step) {
    hideErrors();

    if (step === 1) {
      if (!state.frontFile) {
        frontError.classList.remove('hidden');
        return false;
      }
    }

    if (step === 3) {
      if (state.backType === 'text' && !hasAnyTextLine()) {
        alert('Bitte gib mindestens eine Textzeile für die Rückseite ein.');
        return false;
      }

      if (state.backType === 'handwriting' && !state.handwritingFile) {
        handwritingError.classList.remove('hidden');
        return false;
      }

      if (state.backType === 'portrait' && !state.backPortraitFile) {
        backPortraitError.classList.remove('hidden');
        return false;
      }
    }

    return true;
  }

  function getBackTypeLabel() {
    if (state.backType === 'text') return 'Text';
    if (state.backType === 'handwriting') return 'Handschrift';
    if (state.backType === 'portrait') return 'Weiteres Bild';
    if (state.backType === 'same_as_front') return 'Wie Vorderseite';
    return 'Keine Gravur';
  }

  function getBackTextLines() {
    return [state.backText1, state.backText2, state.backText3].filter(Boolean);
  }

  function getFontLabel() {
    if (state.backFont === 'playfair') return 'Playfair Display';
    if (state.backFont === 'cormorant') return 'Cormorant Garamond';
    if (state.backFont === 'dancing-script') return 'Dancing Script';
    return 'Instrument Sans';
  }

  function getBackSummaryText() {
    if (state.backType === 'text') {
      const lines = getBackTextLines();
      const lineText = lines.length ? lines.join(' / ') : 'Kein Text eingegeben';
      return `Text – ${lineText} (Schrift: ${getFontLabel()})`;
    }

    if (state.backType === 'handwriting') {
      return state.handwritingFile ? `Handschrift – ${state.handwritingFile.name}` : 'Handschrift';
    }

    if (state.backType === 'portrait') {
      return state.backPortraitFile ? `Weiteres Bild – ${state.backPortraitFile.name}` : 'Weiteres Bild';
    }

    if (state.backType === 'same_as_front') {
      return 'Wie Vorderseite';
    }

    return 'Keine Gravur';
  }

  function getGiftBoxLabel() {
    if (state.giftBox === 'black') return 'Schwarze Geschenkbox (+2,00 €)';
    if (state.giftBox === 'white') return 'Weiße Geschenkbox (+2,00 €)';
    return 'Keine Geschenkbox';
  }

  function getAddonTotal() {
    let total = 0;

    if (state.giftBox === 'black' || state.giftBox === 'white') {
      total += 2.0;
    }

    if (state.backType === 'portrait') {
      total += 5.99;
    }

    return total;
  }

  function formatEuro(value) {
    return value.toFixed(2).replace('.', ',') + ' €';
  }

  function renderReview() {
    reviewOutput.innerHTML = `
      <ul>
        <li><strong>Vorderseite:</strong> ${state.frontFile ? state.frontFile.name : '-'}</li>
        <li><strong>Rückseite:</strong> ${getBackSummaryText()}</li>
        <li><strong>Geschenkbox:</strong> ${getGiftBoxLabel()}</li>
        <li><strong>Zusatzkosten gesamt:</strong> +${formatEuro(getAddonTotal())}</li>
      </ul>
    `;
  }

  function renderSummaryOnPage() {
    summaryOutput.innerHTML = `
      <ul>
        <li><strong>Vorderseite:</strong> ${state.frontFile ? state.frontFile.name : '-'}</li>
        <li><strong>Rückseite:</strong> ${getBackSummaryText()}</li>
        <li><strong>Geschenkbox:</strong> ${getGiftBoxLabel()}</li>
        <li><strong>Zusatzkosten gesamt:</strong> +${formatEuro(getAddonTotal())}</li>
      </ul>
    `;

    summaryBox.classList.remove('hidden');
    updateHiddenProperties();

    if (completeInput) {
      completeInput.value = 'Ja';
    }

    if (addButton) {
      addButton.disabled = false;
      addButton.textContent = 'In den Warenkorb';
    }
  }

  function setHiddenInput(form, name, value) {
    let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function updateHiddenProperties() {
    setHiddenInput(productForm, 'properties[Vorderseite]', state.frontFile ? state.frontFile.name : '');
    setHiddenInput(productForm, 'properties[_Vorderseite Upload URL]', state.frontUploadUrl || '');
    setHiddenInput(productForm, 'properties[Rückseite Typ]', getBackTypeLabel());
    setHiddenInput(productForm, 'properties[Rückseite]', getBackSummaryText());
    setHiddenInput(productForm, 'properties[Geschenkbox]', getGiftBoxLabel());
    setHiddenInput(productForm, 'properties[_Handschrift Upload URL]', state.handwritingUploadUrl || '');
    setHiddenInput(productForm, 'properties[_Rückseitenbild Upload URL]', state.backPortraitUploadUrl || '');

    if (state.backType === 'text') {
      setHiddenInput(productForm, 'properties[Text Zeile 1]', state.backText1 || '');
      setHiddenInput(productForm, 'properties[Text Zeile 2]', state.backText2 || '');
      setHiddenInput(productForm, 'properties[Text Zeile 3]', state.backText3 || '');
      setHiddenInput(productForm, 'properties[Schriftart]', getFontLabel());
    } else {
      setHiddenInput(productForm, 'properties[Text Zeile 1]', '');
      setHiddenInput(productForm, 'properties[Text Zeile 2]', '');
      setHiddenInput(productForm, 'properties[Text Zeile 3]', '');
      setHiddenInput(productForm, 'properties[Schriftart]', '');
    }
  }

  function applySelectedFont() {
    const fontFamily = fontMap[state.backFont] || fontMap['instrument-sans'];
    [backTextInput1, backTextInput2, backTextInput3].forEach(input => {
      if (input) input.style.fontFamily = fontFamily;
    });
  }

  function resetPersonalizer() {
    state.frontFile = null;
    state.frontUploadUrl = '';
    state.backType = 'text';
    state.backText1 = '';
    state.backText2 = '';
    state.backText3 = '';
    state.backFont = 'instrument-sans';
    state.handwritingFile = null;
    state.handwritingUploadUrl = '';
    state.backPortraitFile = null;
    state.backPortraitUploadUrl = '';
    state.giftBox = 'none';

    if (frontFileInput) frontFileInput.value = '';
    if (backTextInput1) backTextInput1.value = '';
    if (backTextInput2) backTextInput2.value = '';
    if (backTextInput3) backTextInput3.value = '';
    if (fontSelect) fontSelect.value = 'instrument-sans';
    if (handwritingInput) handwritingInput.value = '';
    if (backPortraitInput) backPortraitInput.value = '';

    frontFileName.textContent = 'Noch kein Bild gewählt';
    handwritingFileName.textContent = 'Noch keine Datei gewählt';
    backPortraitFileName.textContent = 'Noch keine Datei gewählt';

    backTypeInputs.forEach(input => {
      input.checked = input.value === 'text';
    });

    giftBoxInputs.forEach(input => {
      input.checked = input.value === 'none';
    });

    hideErrors();
    updateBackContent();
    applySelectedFont();
    goToStep(1);
    closeModal();

    if (summaryBox) summaryBox.classList.add('hidden');
    if (summaryOutput) summaryOutput.innerHTML = '';

    if (completeInput) {
      completeInput.value = 'Nein';
    }

    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = 'Bitte zuerst personalisieren';
    }

    setHiddenInput(productForm, 'properties[Vorderseite]', '');
    setHiddenInput(productForm, 'properties[_Vorderseite Upload URL]', '');
    setHiddenInput(productForm, 'properties[Rückseite Typ]', '');
    setHiddenInput(productForm, 'properties[Rückseite]', '');
    setHiddenInput(productForm, 'properties[Geschenkbox]', '');
    setHiddenInput(productForm, 'properties[_Handschrift Upload URL]', '');
    setHiddenInput(productForm, 'properties[_Rückseitenbild Upload URL]', '');
    setHiddenInput(productForm, 'properties[Text Zeile 1]', '');
    setHiddenInput(productForm, 'properties[Text Zeile 2]', '');
    setHiddenInput(productForm, 'properties[Text Zeile 3]', '');
    setHiddenInput(productForm, 'properties[Schriftart]', '');
    setHiddenInput(productForm, 'properties[_Personalisierung abgeschlossen]', 'Nein');
  }

  async function uploadFrontImageIfNeeded() {
    if (!state.frontFile) return;
    if (state.frontUploadUrl) return;

    const result = await uploadToUploadcare(state.frontFile);
    state.frontUploadUrl = result.cdnUrl;
  }

  async function uploadHandwritingIfNeeded() {
    if (!state.handwritingFile) return;
    if (state.handwritingUploadUrl) return;

    const result = await uploadToUploadcare(state.handwritingFile);
    state.handwritingUploadUrl = result.cdnUrl;
  }

  async function uploadBackPortraitIfNeeded() {
    if (!state.backPortraitFile) return;
    if (state.backPortraitUploadUrl) return;

    const result = await uploadToUploadcare(state.backPortraitFile);
    state.backPortraitUploadUrl = result.cdnUrl;
  }

  async function uploadSelectedFilesIfNeeded() {
    await uploadFrontImageIfNeeded();

    if (state.backType === 'handwriting') {
      await uploadHandwritingIfNeeded();
    }

    if (state.backType === 'portrait') {
      await uploadBackPortraitIfNeeded();
    }
  }

  function buildCartItems() {
    if (!mainVariantInput || !mainVariantInput.value) {
      throw new Error('Hauptprodukt-Variante nicht gefunden.');
    }

    const items = [];

    items.push({
      id: Number(mainVariantInput.value),
      quantity: 1,
      properties: {
        Vorderseite: state.frontFile ? state.frontFile.name : '',
        _Vorderseite_Upload_URL: state.frontUploadUrl || '',
        'Rückseite Typ': getBackTypeLabel(),
        Rückseite: getBackSummaryText(),
        Geschenkbox: getGiftBoxLabel(),
        _Handschrift_Upload_URL: state.handwritingUploadUrl || '',
        _Rückseitenbild_Upload_URL: state.backPortraitUploadUrl || '',
        'Text Zeile 1': state.backType === 'text' ? (state.backText1 || '') : '',
        'Text Zeile 2': state.backType === 'text' ? (state.backText2 || '') : '',
        'Text Zeile 3': state.backType === 'text' ? (state.backText3 || '') : '',
        Schriftart: state.backType === 'text' ? getFontLabel() : ''
      }
    });

    if (state.giftBox === 'white') {
      items.push({
        id: ADDON_VARIANTS.giftboxWhite,
        quantity: 1,
        properties: {
          _Addon: 'Weiße Geschenkbox'
        }
      });
    }

    if (state.giftBox === 'black') {
      items.push({
        id: ADDON_VARIANTS.giftboxBlack,
        quantity: 1,
        properties: {
          _Addon: 'Schwarze Geschenkbox'
        }
      });
    }

    if (state.backType === 'portrait') {
      items.push({
        id: ADDON_VARIANTS.extraImage,
        quantity: 1,
        properties: {
          _Addon: 'Weiteres Bild'
        }
      });
    }

    return items;
  }

  async function refreshAndOpenCartDrawer() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );

    const drawer = document.getElementById('cart-drawer');

    if (drawer && typeof drawer.show === 'function') {
      setTimeout(() => {
        drawer.show();
      }, 150);
    }
  }

  async function addConfiguredItemsToCart() {
    const items = buildCartItems();

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      let errorMessage = 'Produkt konnte nicht in den Warenkorb gelegt werden.';

      try {
        const errorData = await response.json();
        if (errorData && errorData.description) {
          errorMessage = errorData.description;
        }
      } catch (error) {}

      throw new Error(errorMessage);
    }

    return response.json();
  }

  openButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      closeModal();
    });
  });

  if (!window.__pmEscapeBound) {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        const visibleModal = document.querySelector('[data-pm-modal]:not(.hidden)');
        if (visibleModal) {
          visibleModal.classList.add('hidden');
          visibleModal.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('pm-modal-open');
        }
      }
    });
    window.__pmEscapeBound = true;
  }

  frontFileInput.addEventListener('change', function () {
    state.frontFile = this.files && this.files[0] ? this.files[0] : null;
    state.frontUploadUrl = '';
    frontFileName.textContent = state.frontFile ? state.frontFile.name : 'Noch kein Bild gewählt';
    frontError.classList.add('hidden');
  });

  backTypeInputs.forEach(input => {
    input.addEventListener('change', function () {
      state.backType = this.value;
      updateBackContent();

      if ((this.value === 'none' || this.value === 'same_as_front') && currentStep === 2) {
        goToStep(4);
      }
    });
  });

  backTextInput1.addEventListener('input', function () {
    state.backText1 = this.value.trim();
  });

  backTextInput2.addEventListener('input', function () {
    state.backText2 = this.value.trim();
  });

  backTextInput3.addEventListener('input', function () {
    state.backText3 = this.value.trim();
  });

  fontSelect.addEventListener('change', function () {
    state.backFont = this.value;
    applySelectedFont();
  });

  handwritingInput.addEventListener('change', function () {
    state.handwritingFile = this.files && this.files[0] ? this.files[0] : null;
    state.handwritingUploadUrl = '';
    handwritingFileName.textContent = state.handwritingFile ? state.handwritingFile.name : 'Noch keine Datei gewählt';
    handwritingError.classList.add('hidden');
  });

  backPortraitInput.addEventListener('change', function () {
    state.backPortraitFile = this.files && this.files[0] ? this.files[0] : null;
    state.backPortraitUploadUrl = '';
    backPortraitFileName.textContent = state.backPortraitFile ? state.backPortraitFile.name : 'Noch keine Datei gewählt';
    backPortraitError.classList.add('hidden');
  });

  giftBoxInputs.forEach(input => {
    input.addEventListener('change', function () {
      state.giftBox = this.value;
      if (currentStep === 4) renderReview();
    });
  });

  nextButton.addEventListener('click', function () {
    if (!validateStep(currentStep)) return;

    if (currentStep === 2 && (state.backType === 'none' || state.backType === 'same_as_front')) {
      goToStep(4);
      return;
    }

    if (currentStep < 4) goToStep(currentStep + 1);
  });

  backButton.addEventListener('click', function () {
    if (currentStep === 4 && (state.backType === 'none' || state.backType === 'same_as_front')) {
      goToStep(2);
      return;
    }

    if (currentStep > 1) goToStep(currentStep - 1);
  });

  applyButton.addEventListener('click', async function () {
    const originalText = applyButton.textContent;

    try {
      applyButton.disabled = true;
      applyButton.textContent = 'Speichert...';

      await uploadSelectedFilesIfNeeded();

      renderSummaryOnPage();
      closeModal();
    } catch (error) {
      console.error(error);
      alert('Beim Speichern der Dateien ist ein Fehler aufgetreten. Bitte versuche es erneut.');
    } finally {
      applyButton.disabled = false;
      applyButton.textContent = originalText;
    }
  });

  productForm.addEventListener(
    'submit',
    function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }
    },
    true
  );

  if (addButton) {
    addButton.addEventListener('click', async function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }

      if (completeInput && completeInput.value !== 'Ja') {
        alert('Bitte schließe zuerst die Personalisierung ab.');
        return;
      }

      if (isSubmitting) {
        return;
      }

      isSubmitting = true;

      const originalButtonText = addButton.textContent;

      try {
        addButton.disabled = true;
        addButton.textContent = 'Wird hinzugefügt...';

        await addConfiguredItemsToCart();
        await refreshAndOpenCartDrawer();
        resetPersonalizer();
      } catch (error) {
        console.error(error);
        alert(error.message || 'Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten.');
      } finally {
        isSubmitting = false;

        if (completeInput && completeInput.value === 'Ja') {
          addButton.disabled = false;
          addButton.textContent = originalButtonText || 'In den Warenkorb';
        }
      }
    });
  }

  updateBackContent();
  applySelectedFont();
}

document.addEventListener('DOMContentLoaded', initPersonalizer);

let pmInitTimeout = null;
const pmObserver = new MutationObserver(function () {
  clearTimeout(pmInitTimeout);
  pmInitTimeout = setTimeout(() => {
    initPersonalizer();
  }, 120);
});

pmObserver.observe(document.body, {
  childList: true,
  subtree: true
});